<template>
  <div class="w-product-list">
    <a
      class="w-product-list__item"
      v-for="product in productItems"
      :key="product.code"
      :href="product.url"
    >
      <img
        class="w-product-list__item-image"
        :src="product.logoUrl"
      >
      <div class="w-product-list__item-content">
        <h5 class="w-product-list__item--title">{{ product.title }}</h5>
        <div class="w-product-list__item--description">{{ product.description }}</div>
      </div>
    </a>
  </div>
</template>

<script>
// eslint-disable-next-line @teamwork/cfb-rules/component-paths
import logoProjects from '@/assets/images/product-icon-projects.svg';
import logoChat from '@/assets/images/product-icon-chat.svg';
import logoDesk from '@/assets/images/product-icon-desk.svg';
import logoCRM from '@/assets/images/product-icon-crm.svg';
import logoSpaces from '@/assets/images/product-icon-spaces.svg';

const logos = {
  projects: logoProjects,
  chat: logoChat,
  desk: logoDesk,
  crm: logoCRM,
  spaces: logoSpaces,
};

export default {
  props: {
    /** @type {{ code, url, title, description }} */
    products: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    productItems() {
      return this.products.map((product) => ({ ...product, logoUrl: logos[product.code] }));
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductList.vue?2b7fbdc1